var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
      callback: _vm.visibilityChanged,
      intersection: {
      rootMargin: '0px',
      threshold: 0
      }
  }),expression:"{\n      callback: visibilityChanged,\n      intersection: {\n      rootMargin: '0px',\n      threshold: 0\n      }\n  }"}],staticClass:"carousel-gen-wrp",style:({'height':_vm.height})},[_c('div',{staticClass:"carousel-outer-wrp"},[_c('div',{staticClass:"carousel-inner-wrp",style:({
              'transform':("translateX(" + (_vm.translate.translateX) + "px) translateY(" + (_vm.translate.translateY) + "px)"),
              'transition':this.translate.transition,
              'flex-direction':_vm.direction
          })},[_vm._t("slides",null,{"computedSlides":_vm.computedSlides})],2)]),_vm._t("arrowRight",null,{"carousel":_vm.self}),_vm._t("arrowLeft",null,{"carousel":_vm.self}),_vm._t("navigation",null,{"carousel":_vm.self})],2)}
var staticRenderFns = []

export { render, staticRenderFns }